export default __webpack_public_path__ + "static/media/hamburger.b9808b16.svg";